import { useRef, useState } from "react";
import { useWindowManager } from "../../context/WindowContext";
import { START_BUTTON_SRC, WINDOWS } from "../../data/windows";
import { useClock } from "../../hooks/useClock";
import { Menu } from "../Menu/Menu";
import classes from "./Header.module.css";

export const Header = () => {
  const time = useClock();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const startButtonRef = useRef(null);
  const { isFocused, isOnTaskbar, toggleTaskbar, isMobile } = useWindowManager();

  return (
    <div className={classes.startPanel}>
      {isMenuOpen ? (
        <Menu onClose={setIsMenuOpen} ignoreCloseRef={startButtonRef} />
      ) : null}
      <div className={classes.Header}>
        <div className={classes.panelToolbox}>
          <img
            ref={startButtonRef}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            src={START_BUTTON_SRC}
            alt="start"
            className={isMenuOpen ? `${classes.nowActive}` : null}
          />
          {WINDOWS.map((window) => {
            if ((window.mobileOnly && !isMobile) || !isOnTaskbar(window.id)) {
              return null;
            }

            return (
              <div
                key={window.id}
                onClick={() => toggleTaskbar(window.id)}
                className={`${isFocused(window.id) ? classes.nowActive : null} ${
                  classes.applicationTray
                }`}
              >
                <img src={window.icon} alt={window.iconAlt} />
                <p>{window.taskbarTitle}</p>
              </div>
            );
          })}
        </div>

        <div className={classes.timeBox}>{time}</div>
      </div>
    </div>
  );
};
